import { motion } from "framer-motion";
import { APPROACH, STEPS } from "@/data/content";
import { Reveal, MaskLine, SectionLabel, EASE } from "./Reveal";

const ModeCard = ({ item, i }) => (
  <Reveal delay={i * 0.12} className="group relative bg-[#F6F2E8] border border-[#D8CFBC] p-8 sm:p-12 transition-colors duration-500 hover:bg-[#16302B]" data-testid={`approach-card-${item.key}`}>
    <span className="absolute top-0 left-0 h-[2px] w-12 bg-[#B8874A] transition-[width] duration-700 group-hover:w-full" />
    <div className="flex items-start justify-between">
      <span className="eyebrow">Path {item.letter}</span>
      <span className="font-display italic text-6xl text-[#B8874A]/30 leading-none transition-colors duration-500 group-hover:text-[#B8874A]/60">{item.letter}</span>
    </div>
    <h3 className="font-display mt-6 text-4xl sm:text-5xl text-[#221F1B] transition-colors duration-500 group-hover:text-white">{item.title}</h3>
    <p className="mt-6 text-base sm:text-[17px] leading-[1.8] text-[#5C564E] transition-colors duration-500 group-hover:text-white/75">
      <span className="text-[#221F1B] font-medium transition-colors duration-500 group-hover:text-white">{item.lead}</span> {item.body}
    </p>
  </Reveal>
);

const Steps = () => (
  <div className="relative mt-20 lg:mt-28" data-testid="approach-steps">
    <div className="hidden md:block absolute top-[7px] left-0 right-0 h-px bg-[#D8CFBC]" />
    <motion.div
      className="hidden md:block absolute top-[7px] left-0 h-px bg-[#B8874A] origin-left w-full"
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.8, ease: EASE }}
    />
    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10">
      {STEPS.map((s, i) => (
        <Reveal key={s.title} delay={0.2 + i * 0.2} className="relative pl-8 md:pl-0 border-l border-[#D8CFBC] md:border-0" data-testid={`approach-step-${i + 1}`}>
          <span className="absolute -left-[8px] md:left-0 top-0 h-[15px] w-[15px] rotate-45 border border-[#B8874A] bg-[#EFE9DC]" />
          <p className="eyebrow md:mt-10">{s.n}</p>
          <h4 className="font-display text-3xl sm:text-4xl mt-3 text-[#16302B]">{s.title}</h4>
          <p className="mt-4 text-[15px] leading-[1.8] text-[#5C564E] max-w-sm">{s.body}</p>
        </Reveal>
      ))}
    </div>
  </div>
);

export const Approach = () => (
  <section id="approach" className="relative bg-[#EFE9DC] py-24 sm:py-32 lg:py-40 border-y border-[#D8CFBC]" data-testid="approach-section">
    <div className="max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12">
      <Reveal><SectionLabel index="II.">How I Work</SectionLabel></Reveal>
      <h2 className="font-display mt-8 max-w-4xl text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.12] tracking-[-0.015em] text-[#221F1B]" data-testid="approach-headline">
        <MaskLine inView>A dual approach — coaching and</MaskLine>
        <MaskLine inView delay={0.1}>consulting, <span className="italic text-[#16302B]">chosen to fit you.</span></MaskLine>
      </h2>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-5">
        {APPROACH.map((a, i) => <ModeCard key={a.key} item={a} i={i} />)}
      </div>
      <Reveal className="mt-14 max-w-3xl text-base sm:text-[17px] leading-[1.8] text-[#4A453E]">
        Every engagement begins with a personal Discovery Session, where we identify which path — or what blend of both — is right for your specific stage and challenge. From there, we move through a simple process:
      </Reveal>
      <Steps />
    </div>
  </section>
);
